export default "__VITE_ASSET__lN9_jKs2__"